var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expandable-box"},[_c('button',{staticClass:"title-box",on:{"click":_vm.toggleExpanded}},[_c('h3',[_vm._v(_vm._s((_vm.isExpanded?'- ':'+ ')+ _vm.title))])]),(_vm.isExpanded)?_c('div',{ref:"description",staticClass:"description-box"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }